<div class="row col-12 col-sm-12 my-account-container">
  <div class="col-3 col-sm-3 d-one d-sm-none my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'MyWarrantiesNavNode'"
    [childNavState]="'SubmitWarrantyClaimNavNode'"></app-my-account-left-sidenav>
  </div>

  <div class="submit-warranty-claim col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    <ng-container>
      @if (submittedSuccessFully?.claimNumber) {
        <div class="warranty-header-success-msg">
          <div class="content">
            <cx-page-slot position="ConfirmationContentSlot"></cx-page-slot>
          </div>
        </div>
      }
      @if (isFormContainsError) {
        <div class="warranty-header-alert-msg " style="display: block;">
          <div class="content">
            <p>{{ 'common.form_global_error' | cxTranslate }}</p>
          </div>
        </div>
      }
      @if (submitapierror$ |async; as submiterror) {
        <div class="warranty-header-alert-msg " style="display: block;">
          <div class="content">
            <p>{{ submiterror| cxTranslate }}</p>
          </div>
        </div>
      }
      @if (isFormFilledSuccessfully && !isFormContainsError) {
        <div
          class="warranty-header-warning-msg warning-alert-msg" style="display: block;">
          <div class="content">
            <p>{{ 'common.text_submit_review_carefully' | cxTranslate }}</p>
          </div>
        </div>
      }
    </ng-container>
    <div class="my-section-box">
      <form id="warrantyRequestForm" class="warrantyRequestForm" [formGroup]="warrantyClaimApplication">
        @if (warrantyData$ | async; as warrantyData) {
          <div class="warranty-claim-application-block">
            <h1 class="warranty-claim-headling m-0">{{ 'common.text_submit_warranty' | cxTranslate }}
            </h1>
            <div class="warranty-claim-application-detail">
              <div class="content">
                <cx-page-slot position="TopContent"></cx-page-slot>
              </div>
              <div class="row">
                <div class="col-md-8">
                  <div class="title">{{ 'common.text_warranty_submit_customer_information' | cxTranslate }}</div>
                </div>
                <div class="col-md-4">
                  @if (submittedSuccessFully?.barCodeLabel) {
                    <div class="barCodeImage">
                      <img [src]="baseUrl + submittedSuccessFully?.barCodeLabel?.url"
                        [alt]="submittedSuccessFully?.barCodeLabel?.altText">
                      </div>
                    }
                  </div>
                </div>
                <div class="select warranty-customID-block na-ref-cust-info-box" (click)="$event.stopPropagation()"
                  (keyup.enter)="$event.stopPropagation()">
                  <div class="fs-wrap">
                    <div class="fs-label-wrap">
                      <div class="col-xs-12 col-sm-12 col-md-12 fs-label" (click)="showSearchResults($event)">
                        @if (!selectedCustomerId) {
                          <span class="customer-id-row">
                            {{ 'common.please_select_your_customer_id' | cxTranslate }}
                          </span>
                        }
                        @if (selectedCustomerId) {
                          <span class="customer-id-section">
                            {{ selectedCustomerId?.salesArea1 }}&nbsp;|&nbsp;
                            {{ selectedCustomerId?.salesArea2 | cxTranslate }}&nbsp;|&nbsp;
                            {{ selectedCustomerId?.salesArea3 }}
                          </span>
                        }
                        <input type="hidden" formControlName="soldTo" readonly>
                      </div>
                    </div>
                    @if (showCustomerList) {
                      <app-customer-id-drop-down [customerId]="warrantyData.b2bUnitsWSList"
                        [pageSource]="'warrantyClaim'" (childValue)="selectedCustomerUnit($event)">
                      </app-customer-id-drop-down>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label class="control-label kbclass" for="claimSubmitDate">
                        {{ 'common.text_warranty_submit_date' | cxTranslate }}
                      </label>
                      <input formControlName="claimSubmitDate" class="form-control" type="text" />
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label class="control-label kbclass" for="">
                        {{ 'common.text_warranty_submit_kb_claim_number' | cxTranslate }}
                      </label>
                      <input formControlName="warrantyClaimNumber" readonly class="form-control claim-number-check"
                        type="text" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label class="control-label kbclass" for="claimRefNumber">
                          {{ 'common.text_warranty_submit_claim_ref_number' | cxTranslate }}
                        </label>
                  <input formControlName="claimRefNumber" class="form-control" type="text" [ngClass]="{ 'is-valid': (warrantyClaimForm. claimRefNumber.dirty || isFormContainsError) &&
                    !warrantyClaimForm.claimRefNumber.errors, 'is-invalid':
                    (warrantyClaimForm.claimRefNumber.dirty || isFormContainsError) &&
                    warrantyClaimForm.claimRefNumber.errors }" />
                          <div class="invalid-feedback">
                            @if (warrantyClaimForm.claimRefNumber?.errors &&
                              warrantyClaimForm.claimRefNumber?.touched &&
                              warrantyClaimForm.claimRefNumber?.errors['required']) {
                              <span class="text-danger-show">
                                {{'common.form_field_required'|cxTranslate}}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-lg-3 type-of-operations-outer">
                        <div class="form-group">
                          <label class="control-label selectLabel" for="typeOfOperation">
                            {{ 'common.text_warranty_submit_business_type' | cxTranslate }}
                          </label>
                          <div class="control select">
                            <select class="form-control" formControlName="businessTypes" (change)="onBusinessTypeChange($event)"
                      [ngClass]="{ 'is-valid': (warrantyClaimForm.businessTypes.dirty || isFormContainsError) &&
                      !warrantyClaimForm.businessTypes.errors, 'is-invalid':
                      (warrantyClaimForm.businessTypes.dirty || isFormContainsError) &&
                      warrantyClaimForm.businessTypes.errors }">
                              <option disabled selected value="null">{{ 'common.form_select_empty' | cxTranslate
                              }}</option>
                              @for (option of warrantyData.industryRoles; track option) {
                                <option [value]="option.code">
                                  {{option.name}}
                                </option>
                              }
                            </select>
                            <div class="invalid-feedback">
                              @if (warrantyClaimForm.businessTypes?.touched &&
                                warrantyClaimForm.businessTypes?.errors &&
                                warrantyClaimForm.businessTypes?.errors['required']) {
                                <span class="text-danger-show">
                                  {{'common.form_field_required'|cxTranslate}}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      @if (isDealerSelected) {
                        <div class="col-xs-12 col-sm-6 col-lg-3">
                          <div class="form-group">
                            <label class="control-label kbclass" for="dealerCode">
                              {{ 'common.text_warranty_dealer_code' | cxTranslate }}
                            </label>
                  <input formControlName="dealerCode" class="form-control" type="text" [ngClass]="{ 'is-valid': (warrantyClaimForm.dealerCode.dirty || isFormContainsError) &&
                    !warrantyClaimForm.dealerCode.errors && warrantyClaimApplication.controls.dealerCode.value != '', 'is-invalid':
                    (warrantyClaimForm.dealerCode.dirty || isFormContainsError) &&
                    warrantyClaimForm.dealerCode.errors }" />
                              <div class="invalid-feedback">
                                @if (warrantyClaimForm.dealerCode.touched && warrantyClaimForm.dealerCode.invalid ) {
                                  <span class="text-danger-show"
                                    >
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="row">
                        <div class="col-xs-12 col-sm-6">
                          <div class="form-group">
                            <label class="control-label kbclass" for="email">
                              {{ 'common.login_email' | cxTranslate }}
                            </label>
                  <input formControlName="email" class="form-control" type="text" readonly [ngClass]="{ 'is-valid': (warrantyClaimForm.email.dirty || isFormContainsError) &&
                    !warrantyClaimForm.email.errors, 'is-invalid':
                    (warrantyClaimForm.email.dirty || isFormContainsError) &&
                    warrantyClaimForm.email.errors }" />
                              <div class="invalid-feedback">
                                @if (warrantyClaimForm.email.touched && warrantyClaimForm.email.invalid ) {
                                  <span class="text-danger-show"
                                    >
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="col-xs-12 col-sm-6">
                            <div class="form-group">
                              <label class="control-label kbclass" for="phoneNumber">
                                {{ 'common.register_company_phoneNumber' | cxTranslate }}
                              </label>
                              <input formControlName="phoneNumber" class="form-control" type="text" readonly />
                            </div>
                          </div>
                          <div class="col-xs-12 col-sm-6">
                            <div class="form-group">
                              <label class="control-label kbclass" for="email1">
                                {{ 'common.text_warranty_submit_email1' | cxTranslate }}
                              </label>
                  <input formControlName="email1" class="form-control" [ngClass]="{ 'is-valid': (warrantyClaimForm.email1.dirty) &&
                  !warrantyClaimForm.email1.errors, 'is-invalid':
                  warrantyClaimForm.email1.dirty  &&
                  warrantyClaimForm.email1.errors }" type="text" />
                                <div class="invalid-feedback">
                                  @if (warrantyClaimForm.email1?.touched &&
                                    warrantyClaimForm.email1?.errors) {
                                    <span class="text-danger-show">
                                      {{'common.register_email_invalid'|cxTranslate}}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                              <div class="form-group">
                                <label class="control-label kbclass" for="email2">
                                  {{ 'common.text_warranty_submit_email2' | cxTranslate }}
                                </label>
                  <input formControlName="email2" class="form-control" [ngClass]="{ 'is-valid': (warrantyClaimForm.email2.dirty) &&
                                  !warrantyClaimForm.email2.errors, 'is-invalid':
                                  warrantyClaimForm.email2.dirty  &&
                                  warrantyClaimForm.email2.errors }" type="text" />
                                  <div class="invalid-feedback">
                                    @if (warrantyClaimForm.email2?.touched &&
                                      warrantyClaimForm.email2?.errors) {
                                      <span class="text-danger-show">
                                        {{'common.register_email_invalid'|cxTranslate}}
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-12 col-sm-12">
                                <div class="title"><b>{{ 'common.text_warranty_submit_vehicle_information' | cxTranslate }}</b></div>
                              </div>
                              <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                  <label class="control-label selectLabel" for="typeOfOperation">
                                    {{ 'common.text_warranty_submit_types_operation' | cxTranslate }}
                                  </label>
                                  <div class="control select">
                    <select class="form-control" formControlName="typeOfOperation" [ngClass]="{ 'is-valid': (warrantyClaimForm.typeOfOperation.dirty || isFormContainsError) &&
                      !warrantyClaimForm.typeOfOperation.errors, 'is-invalid':
                      (warrantyClaimForm.typeOfOperation.dirty || isFormContainsError) &&
                      warrantyClaimForm.typeOfOperation.errors }">
                                      <option disabled selected value="null">{{ 'common.form_select_empty' | cxTranslate
                                      }}</option>
                                      @for (option of warrantyData.typeOfOperations; track option) {
                                        <option [value]="option.code">
                                          {{option.name}}
                                        </option>
                                      }
                                    </select>
                                    <div class="invalid-feedback">
                                      @if (warrantyClaimForm.typeOfOperation?.touched &&
                                        warrantyClaimForm.typeOfOperation?.errors &&
                                        warrantyClaimForm.typeOfOperation?.errors['required']) {
                                        <span class="text-danger-show">
                                          {{'common.form_field_required'|cxTranslate}}
                                        </span>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-xs-12 col-sm-6">
                                @if (!isDistributerSelected) {
                                  <div class="form-group">
                                    <label class="control-label selectLabel" for="recallValue">
                                      {{ 'common.warranty_eligibility_check_vehicle_identification_number' | cxTranslate }}*
                                    </label>
                  <input formControlName="vinNumber" type="text" class="form-control" maxlength="17" [ngClass]="{ 'is-valid': (warrantyClaimForm.vinNumber.dirty || isFormContainsError) &&
                    !warrantyClaimForm.vinNumber.errors, 'is-invalid':
                    (warrantyClaimForm.vinNumber.dirty || isFormContainsError) &&
                    warrantyClaimForm.vinNumber.errors }">
                                      <div class="invalid-feedback">
                                        @if (warrantyClaimForm.vinNumber?.touched &&
                                          warrantyClaimForm.vinNumber?.errors &&
                                          warrantyClaimForm.vinNumber?.errors['required']) {
                                          <span class="text-danger-show">
                                            {{'common.form_field_required'|cxTranslate}}
                                          </span>
                                        }
                                        @if (warrantyClaimForm.vinNumber?.touched &&
                                          warrantyClaimForm.vinNumber?.errors &&  !warrantyClaimForm.vinNumber?.errors['required']
                                          ) {
                                          <span class="text-danger-show">
                                            {{'common.warranty_vinError' | cxTranslate}}
                                          </span>
                                        }
                                      </div>
                                    </div>
                                  }
                                  @if (isDistributerSelected) {
                                    <div class="form-group">
                                      <label class="control-label selectLabel" for="recallValue">
                                        {{ 'common.warranty_eligibility_check_vehicle_identification_number' | cxTranslate }}
                                      </label>
                                      <input formControlName="vinNumber" type="text" class="form-control" maxlength="17">
                                    </div>
                                  }
                                </div>
                                <div class="col-xs-12 col-sm-6">
                                  <div class="form-group">
                                    <label class="control-label selectLabel" for="recallValue">
                                      {{ 'common.text_warranty_vehicle_unit_number' | cxTranslate }}
                                    </label>
                                    <input formControlName="vehicleId" type="text" class="form-control" maxlength="17">
                                  </div>
                                </div>
                                <div class="col-xs-12 col-sm-6">
                                  <div class="form-group">
                                    <label class="control-label selectLabel" for="claimTypes">
                                      {{ 'common.text_warranty_vehicle_manufacter' | cxTranslate }}
                                    </label>
                                    <div class="control select">
                                      <select class="form-control" formControlName="vehicleManufacturer"
                                        (change)="onVehicleManufacturerChange($event, warrantyData?.vehicleToChassisMap)">
                                        <option disabled selected value="null">
                                          {{ 'common.form_select_empty' | cxTranslate }}
                                        </option>
                                        @for (item of warrantyData?.vehicleManufacturers; track item) {
                                          <option [value]="item.code">
                                            {{ item.name }}
                                          </option>
                                        }
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-xs-12 col-sm-6">
                                  <div class="form-group"
                                    [ngClass]="{ 'd-none': isVehicleManufacturerSelect && !vehicleToChassisMap?.[0]?.value?.chassisList?.length }">
                                    <label class="control-label selectLabel" for="chassis">
                                      {{ 'common.text_warranty_cahssis_number' | cxTranslate }}
                                    </label>
                                    <div class="control select">
                                      <select class="form-control" formControlName="chassis">
                                        <option disabled selected value="null">
                                          {{ 'common.form_select_empty' | cxTranslate }}
                                        </option>
                                        @for (item of vehicleToChassisMap?.[0]?.value?.chassisList; track item) {
                                          <option [value]="item?.code">
                                            {{ item?.name }}
                                          </option>
                                        }
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-xs-12 col-sm-6">
                                  <div class="form-group">
                                    <label class="control-label selectLabel" for="claimTypes">
                                      {{ 'common.text_warranty_submit_vehicle_engine_manufacturers' | cxTranslate }}
                                    </label>
                                    <div class="control select">
                                      <select class="form-control" formControlName="engineManufacturers">
                                        <option disabled selected value="null">
                                          {{ 'common.form_select_empty' | cxTranslate }}
                                        </option>
                                        @for (option of warrantyData.engineManufacturers; track option) {
                                          <option [value]="option.code">
                                            {{option.name}}
                                          </option>
                                        }
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-xs-12 col-sm-12">
                                  <div class="title"><b>{{ 'common.text_warranty_claim_information' | cxTranslate }}</b></div>
                                </div>
                                <div class="col-xs-12 col-sm-6 type-of-operations-outer">
                                  <div class="form-group">
                                    <label class="control-label selectLabel" for="claimTypes">
                                      {{ 'common.text_warranty_submit_claim_type' | cxTranslate }}
                                    </label>
                                    <div class="control select col-sm-6 col-md-6 col-lg-6 px-0">
                    <select class="form-control" formControlName="claimTypes" (change) = "onClaimTypeChange($event)" [ngClass]="{ 'is-valid': (warrantyClaimForm.claimTypes.dirty || isFormContainsError) &&
                      !warrantyClaimForm.claimTypes.errors, 'is-invalid':
                      (warrantyClaimForm.claimTypes.dirty || isFormContainsError) &&
                      warrantyClaimForm.claimTypes.errors }">
                                        @for (option of warrantyData.claimTypes; track option) {
                                          <option [value]="option.code">
                                            {{option.name}}
                                          </option>
                                        }
                                      </select>
                                      <div class="invalid-feedback">
                                        @if (warrantyClaimForm.claimTypes?.touched &&
                                          warrantyClaimForm.claimTypes?.errors &&
                                          warrantyClaimForm.claimTypes?.errors['required']) {
                                          <span class="text-danger-show">
                                            {{'common.form_field_required'|cxTranslate}}
                                          </span>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                @if (this.warrantyClaimApplication.get('claimTypes').value === 'Recall' ) {
                                  <div
                                    class="col-xs-12 col-sm-6 vin-outer vin-uncond">
                                    <div class="form-group">
                                      <label class="control-label kbclass" for="vinNumber">
                                        {{ 'common.text_warranty_submit_recall_type' | cxTranslate }}
                                      </label>
                                      <div class="control select">
                    <select class="form-control" formControlName="recallValue"  [ngClass]="{ 'is-valid': (warrantyClaimForm.recallValue.dirty || isFormContainsError) &&
                      !warrantyClaimForm.recallValue.errors, 'is-invalid':
                      (warrantyClaimForm.recallValue.dirty || isFormContainsError) &&
                      warrantyClaimForm.recallValue.errors }">
                                          <option disabled selected value="null">{{ 'common.form_select_empty' | cxTranslate
                                          }}</option>
                                          @for (option of warrantyData?.recallNumbers; track option) {
                                            <option [value]="option.code">
                                              {{option.name}}
                                            </option>
                                          }
                                        </select>
                                        <div class="invalid-feedback">
                                          @if (warrantyClaimForm.recallValue?.touched &&
                                            warrantyClaimForm.recallValue?.errors &&
                                            warrantyClaimForm.recallValue?.errors['required']) {
                                            <span class="text-danger-show">
                                              {{'common.form_field_required'|cxTranslate}}
                                            </span>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                                <div class="col-xs-12 col-sm-6 vin-outer vin-uncond">
                                  <div class="form-group">
                                    <label class="control-label kbclass" for="vinNumber">
                                      {{ 'common.text_warranty_tag_serial_number' | cxTranslate }}
                                    </label>
                                    <input formControlName="tagSerialNumber" class="form-control" type="text" maxlength="17" />
                                  </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 type-of-operations-outer">
                                  <div class="form-group">
                                    <label class="control-label selectLabel" for="primaryComplaints">
                                      {{ 'common.text_warranty_submit_primary_complaint' | cxTranslate }}
                                    </label>
                                    <div class="control select">
                    <select class="form-control" formControlName="primaryComplaints" [ngClass]="{ 'is-valid': (warrantyClaimForm.primaryComplaints.dirty || isFormContainsError) &&
                      !warrantyClaimForm.primaryComplaints.errors, 'is-invalid':
                      (warrantyClaimForm.primaryComplaints.dirty || isFormContainsError) &&
                      warrantyClaimForm.primaryComplaints.errors }">
                                        <option disabled selected value="null">{{ 'common.form_select_empty' | cxTranslate
                                        }}</option>
                                        @for (option of warrantyData.primaryComplaints; track option) {
                                          <option [value]="option.code">
                                            {{option.name}}
                                          </option>
                                        }
                                      </select>
                                      <div class="invalid-feedback">
                                        @if (warrantyClaimForm.primaryComplaints?.touched &&
                                          warrantyClaimForm.primaryComplaints?.errors &&
                                          warrantyClaimForm.primaryComplaints?.errors['required']) {
                                          <span class="text-danger-show">
                                            {{'common.form_field_required'|cxTranslate}}
                                          </span>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-6">
                                  <div class="form-group">
                                    <label class="control-label kbclass" for="natureOfDefect">
                                      {{ 'common.text_warranty_submit_part_nature_defect_na' | cxTranslate }}
                                    </label>
                                    <textarea formControlName="natureOfDefect" class="form-control warranty-invoice-textarea"
                                    maxlength="250" spellcheck="false"></textarea>
                                  </div>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-6 processing-textBlock">
                                  <div class="content">
                                    <cx-page-slot position="AttachmentsContentSlot"></cx-page-slot>
                                  </div>
                                  <div class="row">
                                    <div class="col-xs-12 col-sm-12 col-md-12">
                                      <div class="warranty-file-attach">
                                        <button type="button" [disabled]="isUploadAble || submittedSuccessFully?.claimNumber"
                                          (click)="uploadFile(0)" class="btn btn-block blue-btn attachfile">
                                          {{ 'common.text_warranty_view_add_information' | cxTranslate }}
                                        </button>
                                        <p>{{ 'common.text_warranty_view_max_mb' | cxTranslate }}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-xs-12 col-sm-12 col-md-12">
                                      @if (fileLength$ | async; as fileCount) {
                                        <p class="file-count">(
                                          <span id="upload-fileList-result-number-0">
                                            {{ fileCount | json }}
                                          </span>
                                          {{ 'common.text_warranty_attachement_available' | cxTranslate }} )
                                        </p>
                                      } @else {
                                        <p>( <span id="upload-fileList-result-number-0">0</span>
                                        {{ 'common.text_warranty_attachement_available' | cxTranslate }} )
                                      </p>
                                    }
                                    <ng-template #showZero>
                                      <p>( <span id="upload-fileList-result-number-0">0</span>
                                      {{ 'common.text_warranty_attachement_available' | cxTranslate }} )
                                    </p>
                                  </ng-template>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-container formArrayName="partInfoDataList">
                          @for (partInfoControls of partInfoDataList.controls; track partInfoControls; let i = $index) {
                            <ng-container [formGroupName]="i">
                              <mat-accordion [multi]="false">
                                <mat-expansion-panel [expanded]="true">
                                  <mat-expansion-panel-header class="warranty-part-info-head">
                                    <mat-panel-title>
                                      {{ 'common.text_warranty_submit_part_information' | cxTranslate }} &nbsp;
                                      <span class="heading-part-no">{{ '00' + (i + 1) }}</span>
                                      @if (i > 0) {
                                        <img src="/images/close-white.svg" class="removePartNoInfo"
                                          (click)="removePartInfo(i)" alt="Close Icon">
                                      }
                                    </mat-panel-title>
                                  </mat-expansion-panel-header>
                                  <div class="warranty-part-info-block">
                                    <div class="row">
                                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                        @if (prodFound$ | async; as prodFound) {
                                          <div class="form-group">
                                            <label class="control-label kbclass" for="axleNumber0">
                                              {{ 'common.text_warranty_submit_returning_part_number' | cxTranslate }}
                                            </label>
                                            <input formControlName="customerPartNumber" class="form-control"
                              (change)="isEligibleForReturn($event, i)" type="text" [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'customerPartNumber')?.dirty || isFormContainsError) &&
                              !getPartInfoControl(i, 'customerPartNumber')?.errors   && getProdDisplay(i,prodFound), 'is-invalid':
                              (getPartInfoControl(i, 'customerPartNumber')?.dirty || isFormContainsError) &&
                              getPartInfoControl(i, 'customerPartNumber')?.errors }">
                                              <div class="invalid-feedback">
                                                @if (getPartInfoControl(i, 'customerPartNumber')?.touched &&
                                                  getPartInfoControl(i, 'customerPartNumber')?.errors &&
                                                  getPartInfoControl(i, 'customerPartNumber')?.errors['required']) {
                                                  <span class="text-danger-show">
                                                    {{ 'common.form_field_required' | cxTranslate }}
                                                  </span>
                                                }
                                              </div>
                                              @if (!getProdDisplay(i,prodFound)) {
                                                <div class="d-block">
                                                  <span class="text-danger">{{ productNotFound }}</span>
                                                </div>
                                              }
                                            </div>
                                          }
                                        </div>
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                          <div class="form-group">
                                            <label class="control-label kbclass" for="partNumber">
                                              {{ 'common.text_warranty_submit_returning_kbpart_number' | cxTranslate }}
                                            </label>
                                            <input formControlName="partNumber" class="form-control custom-part-number-input"
                                              type="text" readonly>
                                            </div>
                                          </div>
                                          <div class="clearfix"></div>
                                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                            <div class="form-group">
                                              <label class="control-label  kbclass" for="partNumber0">
                                                {{ 'common.text_warranty_submit_part_quantity' | cxTranslate }}
                                              </label>
                                              <input formControlName="quantity" (input)="uiCostCalculator()"
                              class="form-control kb-part-number-input" type="number" [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'quantity').dirty || isFormContainsError) &&
                              !getPartInfoControl(i, 'quantity').errors, 'is-invalid':
                              (getPartInfoControl(i, 'quantity').dirty || isFormContainsError) &&
                              getPartInfoControl(i, 'quantity').errors }" min="1">
                                                <div class="invalid-feedback">
                                                  @if (getPartInfoControl(i, 'quantity')?.touched &&
                                                    getPartInfoControl(i, 'quantity')?.errors &&
                                                    getPartInfoControl(i, 'quantity')?.errors['required']) {
                                                    <span class="text-danger-show">
                                                      {{'common.form_field_required'|cxTranslate}}
                                                    </span>
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                              <div class="form-group">
                                                <label class="control-label kbclass" for="typeNumber0">
                                                  {{ 'common.text_warranty_submit_part_type_number' | cxTranslate }}
                                                </label>
                                                <input formControlName="typeNumber" class="form-control type-no-input" type="text" readonly>
                                              </div>
                                            </div>
                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                              <div class="form-group">
                                                <label class="control-label  kbclass" for="description0">
                                                  {{ 'common.text_warranty_submit_part_description' | cxTranslate }}
                                                </label>
                                                <input formControlName="description" class="form-control description-input" type="text"
                                                  readonly>
                                                </div>
                                              </div>
                                              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                <div class="form-group">
                                                  <label class="control-label  kbclass" for="quantity0">
                                                    {{ 'common.text_warranty_submit_replacement_type' | cxTranslate }}
                                                  </label>
                                                  <div class="control select">
                              <select class="form-control" formControlName="replacementTypes" [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'replacementTypes').dirty || isFormContainsError) &&
                                !getPartInfoControl(i, 'replacementTypes').errors, 'is-invalid':
                                (getPartInfoControl(i, 'replacementTypes').dirty || isFormContainsError) &&
                                getPartInfoControl(i, 'replacementTypes').errors }">
                                                      <option disabled selected value="null">
                                                        {{ 'common.form_select_empty' | cxTranslate }}
                                                      </option>
                                                      @for (option of warrantyData.replacementTypes; track option) {
                                                        <option [value]="option.code">
                                                          {{option.name}}
                                                        </option>
                                                      }
                                                    </select>
                                                    <div class="invalid-feedback">
                                                      @if (getPartInfoControl(i, 'replacementTypes')?.touched &&
                                                        getPartInfoControl(i, 'replacementTypes')?.errors &&
                                                        getPartInfoControl(i, 'replacementTypes')?.errors['required']) {
                                                        <span class="text-danger-show">
                                                          {{'common.form_field_required'|cxTranslate}}
                                                        </span>
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-mileage-block">
                                                <div class="row col-xs-12 col-sm-12 col-md-12 px-0">
                                                  <div class="col-10 col-xs-10 col-sm-9 col-md-7">
                                                    <div class="form-group mileage-input-box">
                                                      <label class="control-label  kbclass" for="mileageInService">
                                                        {{ 'common.text_warranty_submit_part_mileage' | cxTranslate }}
                                                      </label>
                                                      <input formControlName="mileageInService"
                                                        class="form-control mileage-input warranty-mileage" type="text" maxlength="7"
                                                        (keypress)="allowOnlyNumbers($event)"
                                  [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'mileageInService').dirty || isFormContainsError) &&
                                  !getPartInfoControl(i, 'mileageInService').errors, 'is-invalid':
                                  (getPartInfoControl(i, 'mileageInService').dirty || isFormContainsError) &&
                                  getPartInfoControl(i, 'mileageInService').errors }">
                                                        <div class="invalid-feedback">
                                                          @if (getPartInfoControl(i, 'mileageInService')?.touched &&
                                                            getPartInfoControl(i, 'mileageInService')?.errors &&
                                                            getPartInfoControl(i, 'mileageInService')?.errors['required']) {
                                                            <span class="text-danger-show">
                                                              {{'common.form_field_required'|cxTranslate}}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="col-2 col-xs-2 col-sm-3 col-md-5 pr-0">
                                                      <div class="form-group">
                                                        <label class="control-label selectLabel" for="scale">
                                                          {{ 'common.text_warranty_submit_part_scale' | cxTranslate }}
                                                        </label>
                                                        <div class="control select">
                                  <select class="form-control" formControlName="scale" [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'scale').dirty || isFormContainsError) &&
                                    !getPartInfoControl(i, 'scale').errors, 'is-invalid':
                                    (getPartInfoControl(i, 'scale').dirty || isFormContainsError) &&
                                    getPartInfoControl(i, 'scale').errors }">
                                                            <option disabled selected value="null">
                                                              {{ 'common.form_select_empty' | cxTranslate }}
                                                            </option>
                                                            @for (option of warrantyData.maintenanceScales; track option) {
                                                              <option [value]="option.code">
                                                                {{option.name}}
                                                              </option>
                                                            }
                                                          </select>
                                                          <div class="invalid-feedback">
                                                            @if (getPartInfoControl(i, 'scale')?.touched &&
                                                              getPartInfoControl(i, 'scale')?.errors &&
                                                              getPartInfoControl(i, 'scale')?.errors['required']) {
                                                              <span class="text-danger-show">
                                                                {{'common.form_field_required'|cxTranslate}}
                                                              </span>
                                                            }
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                  @if (showAxlePosition$ | async; as showAxlePosition) {
                                                    <div class="form-group ">
                                                      @if (getAxlePosition(i,showAxlePosition) === true) {
                                                        <label class="control-label selectLabel axle-position-label">
                                                          {{ 'common.type_WarrantyPart_axlePosition_name' | cxTranslate }} *
                                                          <a class="axlepositionqIcon">&#63;
                                                            <span class="tooltiptext">{{'common.myaccount_warranty_axlePosition_toolTip'
                                                            |cxTranslate}}</span>
                                                          </a>
                                                        </label>
                                                        <div class="control select">
                                <select class="form-control" formControlName="axlePositions" [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'axlePositions').dirty || isFormContainsError) &&
                                !getPartInfoControl(i, 'axlePositions').errors, 'is-invalid':
                                (getPartInfoControl(i, 'axlePositions').dirty || isFormContainsError) &&
                                getPartInfoControl(i, 'axlePositions').errors }">
                                                            <option disabled selected value="null">
                                                              {{ 'common.form_select_empty' | cxTranslate }}
                                                            </option>
                                                            @for (option of warrantyData.axlePositions; track option) {
                                                              <option [value]="option.code">
                                                                {{option.name}}
                                                              </option>
                                                            }
                                                          </select>
                                                          <div class="invalid-feedback">
                                                            @if (getPartInfoControl(i, 'axlePositions')?.touched &&
                                                              getPartInfoControl(i, 'axlePositions')?.errors &&
                                                              getPartInfoControl(i, 'axlePositions')?.errors['required']) {
                                                              <span class="text-danger-show">
                                                                {{'common.form_field_required'|cxTranslate}}
                                                              </span>
                                                            }
                                                          </div>
                                                        </div>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                  <div class="form-group">
                                                    <label class="control-label" for="inServiceString">
                                                      {{ 'common.warranty_eligibility_check_date_in_service' | cxTranslate }}*
                                                    </label>
                                                    <span class="warranty-info-dateblock">
                                                      <input formControlName="inServiceString" bsDatepicker [maxDate]="today"
                                                        [bsConfig]="{ dateInputFormat: bsconfigDate.toUpperCase() , showWeekNumbers: false, displayOneMonthRange: true }"
                                                        placeholder={{bsconfigDate.toLowerCase()}}
                                                        class="form-control warranty-date-picker-class hasDatepicker bsdpicker kb-datePickerIcon"
                                [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'inServiceString').dirty || isFormContainsError) &&
                                !getPartInfoControl(i, 'inServiceString').errors, 'is-invalid':
                                (getPartInfoControl(i, 'inServiceString').dirty || isFormContainsError) &&
                                getPartInfoControl(i, 'inServiceString').errors }">
                                                        <div class="invalid-feedback">
                                                          @if (getPartInfoControl(i, 'inServiceString')?.errors &&
                                                            getPartInfoControl(i, 'inServiceString')?.errors['required']) {
                                                            <span class="text-danger-show">
                                                              {{'common.form_field_required'|cxTranslate}}
                                                            </span>
                                                          }
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                    <div class="form-group">
                                                      <label class="control-label" for="removedFromServiceString">
                                                        {{ 'common.warranty_eligibility_check_date_removed_from_service' | cxTranslate }}*
                                                      </label>
                                                      <input formControlName="removedFromServiceString" bsDatepicker [maxDate]="today"
                                                        [bsConfig]="{ dateInputFormat: bsconfigDate.toUpperCase()  , showWeekNumbers: false, displayOneMonthRange: true }"
                                                        placeholder={{bsconfigDate.toLowerCase()}}
                                                        class="form-control warranty-date-picker-class hasDatepicker bsdpicker kb-datePickerIcon"
                              [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'removedFromServiceString').dirty || isFormContainsError) &&
                              !getPartInfoControl(i, 'removedFromServiceString').errors, 'is-invalid':
                              (getPartInfoControl(i, 'removedFromServiceString').dirty || isFormContainsError) &&
                              getPartInfoControl(i, 'removedFromServiceString').errors }">
                                                        <div class="invalid-feedback">
                                                          @if (getPartInfoControl(i, 'removedFromServiceString')?.errors &&
                                                            getPartInfoControl(i, 'removedFromServiceString')?.errors['required']) {
                                                            <span class="text-danger-show">
                                                              {{'common.form_field_required'|cxTranslate}}
                                                            </span>
                                                          }
                                                        </div>
                                                        @if (remDateGreatThanServ$ | async; as remDate) {
                                                          <div class="d-block">
                                                            @if (remDate[i] === true) {
                                                              <span class="text-danger">{{ 'common.text_warranty_submit_date_removed_invalid' |
                                                              cxTranslate }}</span>
                                                            }
                                                          </div>
                                                        }
                                                      </div>
                                                    </div>
                                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                      <div class="form-group serial-pdf-block">
                                                        <label class="control-label" for="serialNumber">
                                                          {{ 'common.text_warranty_submit_part_serialno' | cxTranslate }}
                                                          <a [href]="warrantyData?.serialNumberPdf?.url" target="_blank"
                                                          class="questionIcon">&#63;</a>
                                                        </label>
                                                        <div class="form-group">
                                                          <input formControlName="serialNumber" class="form-control" type="text">
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                      <div class="form-group serial-pdf-block">
                                                        <label class="control-label" for="dateCode">
                                                          {{ 'common.text_warranty_submit_part_datecode' | cxTranslate }}
                                                          <a [href]="warrantyData?.dateCodePdf?.url" target="_blank" class="questionIcon">&#63;</a>
                                                        </label>
                                                        <div class="form-group">
                                                          <input formControlName="dateCode" class="form-control" type="text">
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                      <div class="form-group">
                                                        <label class="control-label kbclass" for="invoiceNumber0">
                                                          {{ 'common.text_warranty_submit_parts_disposition' | cxTranslate }}
                                                        </label>
                                                        <!-- partsDisposition -->
                                                        <div class="control select">
                              <select class="form-control" formControlName="partsDisposition" [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'partsDisposition').dirty || isFormContainsError) &&
                                !getPartInfoControl(i, 'partsDisposition').errors, 'is-invalid':
                                (getPartInfoControl(i, 'partsDisposition').dirty || isFormContainsError) &&
                                getPartInfoControl(i, 'partsDisposition').errors }">
                                                            @for (option of warrantyData.partsDisposition; track option) {
                                                              <option [value]="option.code">
                                                                {{ option.name }}
                                                              </option>
                                                            }
                                                          </select>
                                                          <div class="invalid-feedback">
                                                            @if (getPartInfoControl(i, 'partsDisposition').touched &&
                                                              getPartInfoControl(i, 'partsDisposition').invalid) {
                                                              <span class="text-danger-show">
                                                                {{'common.form_field_required'|cxTranslate}}
                                                              </span>
                                                            }
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                      <label class="control-label" for="labourRequested">
                                                        {{'common.text_warranty_submit_part_labour_requested'|cxTranslate}}
                                                      </label>
                                                      <div class="kb-radio">
                                                        <input formControlName="labourRequested" class="labourRequestedYes" type="radio"
                              (change)="businessTypeChange()" [value]="true" [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'labourRequested').dirty || isFormContainsError) &&
                              !getPartInfoControl(i, 'labourRequested').errors, 'is-invalid':
                              (getPartInfoControl(i, 'labourRequested').dirty || isFormContainsError) &&
                              getPartInfoControl(i, 'labourRequested').errors }">
                                                          <label for="labourRequestedYes0">
                                                            {{ 'common.text_quote_yes_button_label' | cxTranslate }}
                                                          </label>
                                                          <input formControlName="labourRequested" class="labourRequestedNo" type="radio"
                              (change)="businessTypeChange()" [value]="false" [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'labourRequested').dirty || isFormContainsError) &&
                              !getPartInfoControl(i, 'labourRequested').errors, 'is-invalid':
                              (getPartInfoControl(i, 'labourRequested').dirty || isFormContainsError) &&
                              getPartInfoControl(i, 'labourRequested').errors }">
                                                            <label for="labourRequestedNo0">
                                                              {{'common.text_warranty_submit_labourrequested_no' | cxTranslate}}
                                                            </label>
                                                            <div class="invalid-feedback">
                                                              @if (getPartInfoControl(i, 'labourRequested')?.errors &&
                                                                getPartInfoControl(i, 'labourRequested')?.errors['required']) {
                                                                <span class="text-danger-show">
                                                                  {{'common.form_field_required'|cxTranslate}}
                                                                </span>
                                                              }
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <!-- Requested cost reimbursement section -->
                                                      <div class="row mt-5">
                                                        <div class="col-xs-12 col-sm-12">
                                                          <div class="title requested-cost-title mb-4 mt-4">
                                                            <b class="fsb">
                                                              {{ 'common.text_warranty_submit_requested_cost' | cxTranslate }}
                                                            </b>
                                                            <sub class="fssub">{{ 'common.text_warranty_submit_enter_amount' | cxTranslate }}</sub>
                                                          </div>
                                                        </div>
                                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                          <div class="form-group">
                                                            <label class="control-label selectLabel" for="recallValue">
                                                              {{ 'common.text_warranty_submit_part_requestedPartAmount' | cxTranslate }}
                                                            </label>
                                                            <input formControlName="requestedPartAmount" (input)="uiCostCalculator()" type="number"
                              class="form-control" [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'requestedPartAmount').dirty || isFormContainsError) &&
                              !getPartInfoControl(i, 'requestedPartAmount').errors, 'is-invalid':
                              (getPartInfoControl(i, 'requestedPartAmount').dirty || isFormContainsError) &&
                              getPartInfoControl(i, 'requestedPartAmount').errors }">
                                                              <div class="invalid-feedback">
                                                                @if (getPartInfoControl(i, 'requestedPartAmount')?.errors &&
                                                                  getPartInfoControl(i, 'requestedPartAmount')?.errors['required'] && isFormContainsError) {
                                                                  <span class="text-danger-show"
                                                                    >
                                                                    {{'common.form_field_required'|cxTranslate}}
                                                                  </span>
                                                                }
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                            <div class="form-group">
                                                              <label class="control-label selectLabel" for="recallValue">
                                                                {{ 'common.text_warranty_submit_part_requestedHandlingAmount' | cxTranslate }}
                                                              </label>
                                                              <input formControlName="requestedHandlingAmount" type="number" class="form-control"
                              [ngClass]="{ 'is-valid': (getPartInfoControl(i, 'requestedHandlingAmount').dirty || isFormContainsError) &&
                              !getPartInfoControl(i, 'requestedHandlingAmount').errors, 'is-invalid':
                              (getPartInfoControl(i, 'requestedHandlingAmount').dirty || isFormContainsError) &&
                              getPartInfoControl(i, 'requestedHandlingAmount').errors }">
                                                                <div class="invalid-feedback">
                                                                  @if (getPartInfoControl(i, 'requestedHandlingAmount')?.errors &&
                                                                    getPartInfoControl(i, 'requestedHandlingAmount')?.errors['required']) {
                                                                    <span class="text-danger-show">
                                                                      {{'common.form_field_required'|cxTranslate}}
                                                                    </span>
                                                                  }
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div class="col-xs-12 col-sm-12 col-mg-12 col-lg-6">
                                                              <div class="form-group">
                                                                <label class="control-label selectLabel" for="recallValue">
                                                                  {{ 'common.text_warranty_submit_part_hourlyLabourRate' | cxTranslate }}
                                                                </label>
                                                                <input formControlName="hourlyLabourRate" (input)="uiCostCalculator()" type="number"
                                                                  class="form-control">
                                                                  @if (!getPartInfoControl(i, 'hourlyLabourRate').disabled &&
                                                                    getPartInfoControl(i, 'hourlyLabourRate').touched &&
                                                                    !getPartInfoControl(i, 'hourlyLabourRate').value) {
                                                                    <div>
                                                                      <b class="text-danger">
                                                                        {{ 'common.hourly_labour_rate_error_text' | cxTranslate }}
                                                                      </b>
                                                                    </div>
                                                                  }
                                                                </div>
                                                              </div>
                                                              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                                <div class="form-group">
                                                                  <label class="control-label selectLabel" for="recallValue">
                                                                    {{ 'common.text_warranty_submit_part_repairTime' | cxTranslate }}
                                                                  </label>
                                                                  <input formControlName="repairTime" (input)="uiCostCalculator()" type="number"
                                                                    class="form-control">
                                                                    @if (getPartInfoControl(i, 'hourlyLabourRate').value && !getPartInfoControl(i, 'repairTime').value) {
                                                                      <div
                                                                        >
                                                                        <b class="text-danger">
                                                                          {{ 'common.repair_time_error_text' | cxTranslate }}
                                                                        </b>
                                                                      </div>
                                                                    }
                                                                  </div>
                                                                </div>
                                                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                                  <div class="form-group">
                                                                    <label class="control-label selectLabel" for="recallValue">
                                                                      {{ 'common.text_warranty_submit_part_labourAmount' | cxTranslate }}
                                                                    </label>
                                                                    <input formControlName="labourAmount" type="text" class="form-control" readonly>
                                                                  </div>
                                                                </div>
                                                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                                  <div class="form-group">
                                                                    <label class="control-label selectLabel" for="recallValue">
                                                                      {{ 'common.text_warranty_submit_part_otherCost' | cxTranslate }}
                                                                    </label>
                                                                    <input formControlName="otherCost" (input)="uiCostCalculator()" type="number"
                                                                      class="form-control">
                                                                    </div>
                                                                  </div>
                                                                  <div class="col-12">
                                                                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6 px-0">
                                                                      <label class="control-label selectLabel" for="recallValue">
                                                                        {{ 'common.text_warranty_submit_part_otherCostDescription' | cxTranslate }}
                                                                      </label>
                                                                      <input formControlName="otherCostDescription" type="text" class="form-control">
                                                                    </div>
                                                                  </div>
                                                                  <div class="col-12">
                                                                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6 px-0">
                                                                      <label class="control-label selectLabel" for="recallValue">
                                                                        {{ 'common.text_warranty_submit_part_totalCost' | cxTranslate }}*
                                                                      </label>
                                                                      <input formControlName="totalCost" type="text" class="form-control" readonly>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </mat-expansion-panel>
                                                          </mat-accordion>
                                                        </ng-container>
                                                      }
                                                    </ng-container>
                                                    <div class="add-part-number-box">
                                                      <div class="row">
                                                        <div class="col-xs-12 col-sm-12 warranty-additional-box">
                                                          <div class="content">
                                                            <cx-page-slot position="BottomContent"></cx-page-slot>
                                                          </div>
                                                          <div class="row">
                                                            <div class="col-xs-12 col-sm-12">
                                                              <button type="button" class="btn blue-btn add-part-no-btn" (click)="addPartNumber()"
                                                                [disabled]="submittedSuccessFully?.claimNumber">
                                                                {{ 'common.text_warranty_submit_part_add' | cxTranslate }}
                                                              </button>
                                                            </div>
                                                          </div>
                                                          <div class="row">
                                                            <div class="col-xs-12 col-sm-12 submit-buttons">
                                                              <button type="button" class="btn final-review yellow-btn final-review-btn"
                                                                (click)="submitReviewWarrantyClaim()" [disabled]="submittedSuccessFully?.claimNumber">
                                                                {{ 'common.checkout_summary_reviewYourOrder' | cxTranslate }}
                                                              </button>
                                                              <button class="btn  warranty-submit" type="submit"
                                                                [disabled]="!isReviewed || submittedSuccessFully?.claimNumber" (click)="submitWarrantyClaim()">
                                                                {{ 'common.text_warranty_submit_button' | cxTranslate }}
                                                                <img src="/icons/link-dark-grey.svg" alt="Link Icon">
                                                              </button>
                                                            </div>
                                                          </div>
                                                          @if (submittedSuccessFully?.warrantyPdf) {
                                                            <div class="row">
                                                              <div class="col-xs-12 col-sm-12 text-center">
                                                                <a class="btn yellow-btn warranty-print-btn" target="_blank" download
                                                                  [href]="baseUrl + submittedSuccessFully?.warrantyPdf.url">
                                                                  {{ 'common.text_warranty_print' | cxTranslate }}
                                                                </a>
                                                              </div>
                                                            </div>
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                }
                                              </form>
                                            </div>
                                          </div>
                                        </div>

                                        <ng-template #popUpBoxFileUpload>
                                          <div id="warranty-submit-block0" class="warranty-submit-upload">
                                            <div class="popup-upload-headline">
                                              <h3>{{ 'common.text_warranty_upload_file' | cxTranslate }}</h3>
                                              <button class="btn btn-link upload-close" (click)="closePopUpBoxFileUpload()"></button>
                                            </div>
                                            <div class="popup-upload-body">
                                              <p class="attach-body-heading">
                                                {{ 'common.text_warranty_select_file_wish' | cxTranslate }}
                                              </p>
                                              <div class="popup-upload-wrapper files" id="files0">
                                                <input type="hidden" class="hiddenLoopIndex" value="0" aria-hidden="true">
                                                @if (isUploadfileSuccess) {
                                                  <div class="popup-alert-msg files-success-alert">
                                                    <img src="/images/info-green.svg" alt="success">
                                                    <span class="text">{{ 'common.text_warranty_select_all_files' | cxTranslate }}</span>
                                                  </div>
                                                }
                                                @if (isMaxFileSize) {
                                                  <div class="popup-alert-msg files-danger-alert">
                                                    <img src="/images/info-red.svg" alt="error">
                                                    <span class="text">
                                                      {{ 'common.text_select_you_can_upload' | cxTranslate }}
                                                    </span>
                                                  </div>
                                                }
                                                @if (isDuplicateFile) {
                                                  <div class="popup-alert-msg files-danger-alert-duplicate">
                                                    <img src="/images/info-red.svg" alt="info">
                                                    <span class="text">
                                                      {{ 'common.text_warranty_duplicate_file_error' | cxTranslate }}
                                                    </span>
                                                  </div>
                                                }
                                                <p>{{ 'common.text_select_you_path_upload' | cxTranslate }}</p>
                                                <p></p>
                                                <div class="row">
                                                  <div class="col-xs-12 col-sm-12 col-md-9">
                                                    <input type="file" formControlName="filesUploadList" #file (input)="fileSelector(file)"
                                                      accept=".doc, .docx, .xls, .xlsx, .csv, .txt, .tif, .gif, .jpg, .pdf, image/*, .HTML"
                                                      class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no" multiple />
                                                    </div>
                                                    <div class="col-xs-12 col-sm-12 col-md-3 upload-btn-block">
                                                      <button class="btn btn-primary blue-btn create-file-data-btn uploadAttachment"
                                                        (click)="fileUploadFunction()" type="button" [disabled]="isAtleastOnefileIsThere">
                                                        {{ 'common.text_warranty_button_uploadFile' | cxTranslate }}
                                                      </button>
                                                    </div>
                                                  </div>
                                                  <div class="warranty-upload-note">
                                                    {{ 'common.text_select_file_type_upload' | cxTranslate }}<br>
                                                  </div>
                                                  <div class="popup-upload-fileLists">
                                                    @if (fileLength$|async; as filecount ) {
                                                      <div class="upload-fileList-result">
                                                        {{ 'common.text_select_you_record_sets' | cxTranslate }}
                                                        <span class="upload-fileList-result-number">{{ filecount }}</span>
                                                      </div>
                                                    } @else {
                                                      <div class="upload-fileList-result">
                                                        {{ 'common.text_select_you_record_sets' | cxTranslate }}
                                                        <span class="upload-fileList-result-number">0</span>
                                                      </div>
                                                    }
                                                    <ng-template #noFiles>
                                                      <div class="upload-fileList-result">
                                                        {{ 'common.text_select_you_record_sets' | cxTranslate }}
                                                        <span class="upload-fileList-result-number">0</span>
                                                      </div>
                                                    </ng-template>
                                                    <ul>
                                                      <li class="hidden-xs hidden-sm">
                                                        <ul class="item__list--header upload-table-labels">
                                                          <li class="item__sort">#</li>
                                                          <li class="item__name">{{ 'common.text_warranty_name' | cxTranslate }}</li>
                                                          <li class="item__size">{{ 'common.text_warranty_size' | cxTranslate }}</li>
                                                          <li class="item__remove"></li>
                                                        </ul>
                                                      </li>
                                                      <li class="item__list--item js-li-container upload-block">
                                                        @if (fileCurrentFiles$|async; as currentFiles) {
                                                          @for (file of currentFiles; track file; let i = $index) {
                                                            <ul class="fileList">
                                                              <li>
                                                                <div class="item__sort_tr">{{ i+1 }}</div>
                                                                <div class="item__name_tr">{{currentFiles[i].name}}</div>
                                                                <div class="item__size_tr">{{currentFiles[i].size | number : '1.2-2'}}Kb</div>
                                                                <div class="removeFile_tr">
                                                                  <button class="btn btn-link" (click)="removefile(file)">
                                                                    {{ 'common.text_remove' | cxTranslate }}
                                                                  </button>
                                                                </div>
                                                              </li>
                                                            </ul>
                                                          }
                                                        }
                                                      </li>
                                                    </ul>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </ng-template>